import { CERCA_FERMATA} from './CercaFermataTypes'

const initialState = {
    cercaFermata: ""
}

const cercaFermataReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case CERCA_FERMATA:
            
            return {
                cercaFermata: action.load
            }
    
        default:
          return state
    }

}


export default cercaFermataReducer;